import { useEffect, useState } from 'react';
import { loadConfig, type AppConfig } from './config';

// Deployment check page: proves the web app, its runtime config and the API are wired together.
// Replaced by the real app shell (design system, EN/FR, sign-in) in the next step.

type ApiStatus = 'checking' | 'ok' | 'down';

export function App() {
  const [config, setConfig] = useState<AppConfig | null>(null);
  const [api, setApi] = useState<ApiStatus>('checking');

  useEffect(() => {
    loadConfig()
      .then(async (c) => {
        setConfig(c);
        const res = await fetch(`${c.apiUrl}/health`);
        setApi(res.ok ? 'ok' : 'down');
      })
      .catch(() => setApi('down'));
  }, []);

  return (
    <main className="shell">
      <section className="card">
        <img src="/clairo-mark.svg" alt="" width={56} height={56} />
        <h1>
          Clairo<span>Health</span>
        </h1>
        <p className="lede">Home care, made clear.</p>
        <dl>
          <div>
            <dt>Environment</dt>
            <dd>{config?.environment ?? '…'}</dd>
          </div>
          <div>
            <dt>API</dt>
            <dd className={`status status-${api}`}>
              <span aria-hidden="true" className="dot" />
              {api === 'checking' ? 'Checking…' : api === 'ok' ? 'Healthy' : 'Unreachable'}
            </dd>
          </div>
        </dl>
      </section>
    </main>
  );
}
